<template>

    <div class="content-overlay">

        <div class="in-content del" :class="{ clsng : Global.tempClosingOverlay }">

            <h5>
                <span class="txt-grt">Are you sure?</span>
            </h5>
            <ContentCard v-if="asset"
                :posterSrc="asset.poster"
                :moneyTag="Global.plans[asset.planIndex].name"
                :title="asset.name"
                :genreTags="asset.tags"
                :can-delete="false"
            >
            </ContentCard>
            <p class="c-cap txt-ctr">You are about to delete this content. This operation is irreversible.</p>
            <div class="ctas">
                <div class="btn bck" @click.prevent="close">
                    <span class="txt">Cancel</span>
                </div>
                <div class="btn main txt-blk" @click.prevent="delCard">
                    <span class="hvr"></span>
                    <span class="txt">Yes, delete</span>
                </div>
            </div>

        </div>
        
    </div>

</template>

<script>

    import Global from '../../lib/GlobalState'
    import ContentCard from '../../components/ContentCard'

    export default {

        name: 'DeleteContentOverlay',

        components: {
            ContentCard
        },

        props: {
            
        },

        data() {
            return {
                Global,
                asset: null
            }
        },

        mounted() {
            this.asset = this.Global.assets[this.Global.contentIndexToDelete]
        },

        methods: {

            close() {
                this.Global.tempClosingOverlay = true
                setTimeout(() => { this.Global.activeBlurredOverlay = false }, 300)
                setTimeout(() => { this.Global.activeDelOverlay = false }, 600)
            },

            delCard() {
                this.Global.assets.splice(this.Global.contentIndexToDelete, 1)
                this.close()
            }
        }
    }
</script>